import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { LIST_MEDIA_AGENT_POOL_QUERY_KEY } from '@/state/queries/media-agent-admin/use-list-media-agent-pool';

export function usePairMediaAgentDeviceMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: { code: string; playerId: string }) => {
      const token = (await getToken()) ?? '';
      const url = `${import.meta.env.VITE_API_URL}/media-agent/pair-device`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('Failed to pair media agent');
      return res.json() as Promise<{ playerId: string; token: string }>;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [LIST_MEDIA_AGENT_POOL_QUERY_KEY] }),
  });
}

export function useForceReleaseMediaAgentMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (playerId: string) => {
      const token = (await getToken()) ?? '';
      const url = `${import.meta.env.VITE_API_URL}/media-agent/actions/force-release`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ playerId }),
      });
      if (!res.ok) throw new Error('Failed to force release media agent');
      return res.json();
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [LIST_MEDIA_AGENT_POOL_QUERY_KEY] }),
  });
}
